import api from "../../api";
// import _ from "lodash";
import * as types from "../mutation-types";

const createMaterialSlug = post => {
  let link = post.link;
  let nohost = link.split('//')[1];
  let slugs = nohost.split("/");
  slugs.shift();
  let slug = slugs.join('/');
  // console.log(slug);
  post.path = '/' + slug;
  return post;
};

// initial state
const state = {
  recent: [],
  loaded: false,
  total: 0
};

// getters
const getters = {
  recentMaterials: state => limit => {
    if (
      !limit ||
      !_.isNumber(limit) ||
      _.isNull(limit) ||
      typeof limit == "undefined"
    ) {
      return state.recent;
    }
    let recent = state.recent;
    return recent.slice(0, limit);
  },

  recentMaterialsLoaded: state => state.loaded,
  recentMaterialsTotal: state => state.total,
};

// actions
const actions = {
  getMaterials({
    commit
  }, {
    limit,
    paged,
    q
  }) {
    // console.log("action", "getMaterials");
    api.getMaterials(limit, paged, q, material => {

      if (material.data) {
        material.data.map((post, i) => {
          let _post = post;
          _post = createMaterialSlug(post);
          _post.children.map((child, j) => {
            let _child = child;
            // console.log("child",child);
            _child = createMaterialSlug(_child);
            _post.children[j] = _child;
          })
          material.data[i] = _post;
        });
      } else {
        console.log("getMaterials err", material);
      }

      let total = Number(material.headers['x-wp-total']);
      // this.total_pages = Number(material.headers['x-wp-totalpages']);
      // console.log("material total", total);

      commit(types.STORE_FETCHED_MATERIALS_TOTAL, total);
      commit(types.STORE_FETCHED_MATERIALS, {
        material
      });
      commit(types.MATERIALS_LOADED, true);
      commit(types.INCREMENT_LOADING_PROGRESS);
    });
  }
};

// mutations
const mutations = {
  [types.STORE_FETCHED_MATERIALS_TOTAL](state, val) {
    state.total = val;
  },
  [types.STORE_FETCHED_MATERIALS](state, {
    material
  }) {
    state.recent = material.data;
  },

  [types.MATERIALS_LOADED](state, val) {
    state.loaded = val;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};